export const NESTED_STORE_LOCATOR_SLUG = "nested-store-locator" as const;
export const COUNT_PLACEHOLDER = "{count}" as const;
export const CITY_PLACEHOLDER = "{city}" as const;
export const STORE_PLACEHOLDER = "{store}" as const;
export const PROVINCE_PLACEHOLDER = "{province}" as const;
